module.exports = __webpack_public_path__ + "static/media/edit-connection.661644d8.svg";